import React, { useMemo } from 'react';
import styles from './TabLayout.module.scss';
import IconStudyMode from 'src/assets/icons/book.svg?react';
import IconEditMode from 'src/assets/icons/hepencil.svg?react';
import { MyQuizEnum } from '@types';
import { useMediaQuery } from 'react-responsive';
import { GettingStartedMode, CareGiverMode } from '@src/constants';

type Props = {
  studyMode: string;
  topPos: number;
  handleSelectPlanMode?: (studyMode: any) => void;
  isGettingStarted?: boolean;
  isCaregiver?: boolean;
  isUser?: boolean;
};

const getIconByType = (type: MyQuizEnum) => {
  switch (type) {
    case MyQuizEnum.QuizBuilder:
      return IconEditMode;
    case MyQuizEnum.MyQuizzes:
      return IconStudyMode;
    default: {
      return IconEditMode;
    }
  }
}

function TabLayout(props: Props) {
  const { studyMode, topPos, handleSelectPlanMode, isGettingStarted, isCaregiver } = props;
  const middleWidth = useMediaQuery({maxWidth: 1330});
  const smallWidth = useMediaQuery({maxWidth: 1024});

  const isTablet = useMemo(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent)
  }, []);

  const _filtered = useMemo(() => {
    if (isGettingStarted) {
      return GettingStartedMode;
    }
    if (isCaregiver) {
      return CareGiverMode;
    }
    return (Object.keys(MyQuizEnum) as (keyof typeof MyQuizEnum)[]).map((key) => {
        return MyQuizEnum[key];
      },
    );
  }, [isCaregiver, isGettingStarted]);

  var height = middleWidth ? smallWidth ? 120 : 160 : 203;
  const leftScrollView = document.getElementById("navMenuBar")
  if (leftScrollView) {
    const rect = leftScrollView.getBoundingClientRect();
    if (topPos >= 88) {
      height = middleWidth ? smallWidth ? 120 : 160 : 203;
    } else if (rect.height - (87 - topPos) < 90) {
      height = 90;
    } else {
      height = rect.height - (87 - topPos);
    }
  }

  return (
    <div id={"navMenuBar"} className={`${studyMode === MyQuizEnum.MyQuizzes ? styles.studyModeNavView : styles.navView} ${isTablet ? '' : topPos < 88 ? styles.courseHeadStickyView : styles.headStickyView}`} style={{height: topPos < 88 ? '90px' : `${height}px`}}>
      {_filtered.map((item, index) => {
        const Icon = getIconByType(item as MyQuizEnum);
        return (
          <div key={index} className={styles.itemWrapper} onClick={() => handleSelectPlanMode?.(item)}>
            <div className={[styles.listItem, (studyMode === item && height > 100) ? styles.selItem : ''].join(' ')}>
              <Icon className={[styles.icon, studyMode === item ? styles.selIcon : ''].join(' ')}/>
              <div className={[styles.listTitle, studyMode === item ? styles.selItemTitle : ''].join(' ')}>
                {item}
              </div>
            </div>
          </div>
        )
      })}
    </div>
  );
}

export default TabLayout;
